import { useTranslation } from "react-i18next";
import { TextPresets } from "@/features/standaardteksten/TextPresets";
import { BeheerderShell } from "@/components/BeheerderShell";

export function TextPresetsPage() {
  const { t } = useTranslation(["paginas", "navigatie"]);

  return (
    <BeheerderShell
      titel={t("navigatie:paginas.standaardteksten.label")}
      uitleg={t("standaardteksten.uitleg")}
    >
      <TextPresets />
    </BeheerderShell>
  );
}
